<template>
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10 col-sm-12">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="Account" name="Account">
          <Account-Profile v-on:changetab="changeTab"/>
        </el-tab-pane>
        <el-tab-pane label="Spiffs & Leads" name="Spiffs&Leads">
          <Spiffs-Leads-Setup v-on:changetab="changeTab"/>
        </el-tab-pane>
        <!-- <el-tab-pane label="Affiliate Companies" name="AffiliateCompanies">
          <Affiliate-Companies-Setup/>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="Users" name="Users">
          <Users-Setup/>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeTab: 'Account'
      }
    },
    methods: {
      handleClick (tab, event) {
        //console.log(tab, event)
      },
      changeTab (tab) {
        this.activeTab = tab
      }
    }
  }

</script>
<style>

</style>
